import { z } from "zod/mini"

import type { BooleanModel } from "./boolean"
import { BooleanModelSchema } from "./boolean"
import type { ColorModel } from "./color"
import { ColorModelSchema } from "./color"
import type { DateModel } from "./date"
import { DateModelSchema } from "./date"
import type { EmbedModel } from "./embed"
import { EmbedModelSchema } from "./embed"
import type { GeoPointModel } from "./geopoint"
import { GeoPointModelSchema } from "./geopoint"
import type { ImageModel } from "./image"
import { ImageModelSchema } from "./image"
import type { IntegrationFieldModel } from "./integrationField"
import { IntegrationFieldModelSchema } from "./integrationField"
import type { LinkModel } from "./link"
import { LinkModelSchema } from "./link"
import type { NumberModel } from "./number"
import { NumberModelSchema } from "./number"
import type { RangeModel } from "./range"
import { RangeModelSchema } from "./range"
import type { RichTextModel } from "./richText"
import { RichTextModelSchema } from "./richText"
import type { SelectModel } from "./select"
import { SelectModelSchema } from "./select"
import type { SeparatorModel } from "./separator"
import { SeparatorModelSchema } from "./separator"
import type { TableModel } from "./table"
import { TableModelSchema } from "./table"
import type { TextModel } from "./text"
import { TextModelSchema } from "./text"
import type { TimestampModel } from "./timestamp"
import { TimestampModelSchema } from "./timestamp"

export const NestableModelSchema = z.discriminatedUnion("type", [
	BooleanModelSchema,
	ColorModelSchema,
	DateModelSchema,
	EmbedModelSchema,
	GeoPointModelSchema,
	ImageModelSchema,
	IntegrationFieldModelSchema,
	LinkModelSchema,
	NumberModelSchema,
	RangeModelSchema,
	RichTextModelSchema,
	SelectModelSchema,
	SeparatorModelSchema,
	TableModelSchema,
	TextModelSchema,
	TimestampModelSchema,
])

export type NestableModel =
	| BooleanModel
	| ColorModel
	| DateModel
	| EmbedModel
	| GeoPointModel
	| ImageModel
	| IntegrationFieldModel
	| LinkModel
	| NumberModel
	| RangeModel
	| RichTextModel
	| SelectModel
	| SeparatorModel
	| TableModel
	| TextModel
	| TimestampModel
